export default "__VITE_ASSET__C2qQY0kb__"